
import React, { useEffect, useContext, useState, useMemo } from 'react'
import { LoadingContext } from "react-router-loading";
import { TokenVerificationLoggedin, BlockOtherThanAdmin, ScreenView } from "../../utils/tokenVerify";
import { Radio, Col, Row, Button, Tooltip } from 'antd';
import configData from "../../config/config.json";
import axios from "axios";
import Cookies from "js-cookie";

const AdsTxtPublisher = () => {
    const loadingContext = useContext(LoadingContext);

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockOtherThanAdmin()
        ScreenView()
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(configData.SERVER_URL + `app-ads/adstxtLive`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {

                    if (response.data.data) {
                        setData(
                            response.data.data
                        )
                    }

                })
                .catch((error) => {
                    setData({
                        "website": {
                            "exhaustive": [],
                            "direct": [],
                            "top": []
                        },
                        "mobile": {
                            "exhaustive": [],
                            "direct": [],
                            "top": []
                        },
                        "ctv": {
                            "exhaustive": [],
                            "direct": [],
                            "top": []
                        }
                    })

                });

        }
        loadingContext.done()
    }, [loadingContext]);

    const [tab, setTab] = useState("top")
    function handleTabChange(event) {
        setTab(event.target.value)
    }

    const [data, setData] = useState({
        "website": {
            "exhaustive": [],
            "direct": [],
            "top": []
        },
        "mobile": {
            "exhaustive": [],
            "direct": [],
            "top": []
        },
        "ctv": {
            "exhaustive": [],
            "direct": [],
            "top": []
        }
    })




    //sample object structure //----------------------------------------------

    // {
    //     "website": {
    //         "exhaustive": [
    //             "ex lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //             "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //             "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //             "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //         ],
    //             "direct": [],
    //                 "top": [
    //                     "top lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                     "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                     "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //                     "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //                 ]
    //     },
    //     "mobile": {
    //         "exhaustive": [
    //             "ex lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //             "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //             "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //             "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //         ],
    //             "direct": [
    //                 "direct lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                 "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                 "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //                 "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //             ],
    //                 "top": [
    //                     "top lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                     "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                     "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //                     "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //                 ]
    //     },
    //     "ctv": {
    //         "exhaustive": [
    //             "ex lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //             "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //             "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //             "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //         ],
    //             "direct": [
    //                 "direct lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                 "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                 "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //                 "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //             ],
    //                 "top": [
    //                     "top lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                     "lijit.com, 585769-eb, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                     "openx.com, 538959099, RESELLER, 6a698e2ec38604c6",
    //                     "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace"
    //                 ]
    //     }
    // }




    const currentText = useMemo(() => {
        return (data?.website?.[tab] || []).join("\n");
    }, [data, tab]);

    const lineCount = useMemo(() => {
        return (data?.website?.[tab] || []).length;
    }, [data, tab]);

    const [tooltipContent, setTooltipContent] = useState("Click to copy")

    function copyToClipboard(text) {
        // Check if the Clipboard API is supported
        if (navigator.clipboard && navigator.clipboard.writeText) {
            // Use Clipboard API to copy text to clipboard
            navigator.clipboard.writeText(text)
                .then(() => {
                    // console.log("Text copied to clipboard successfully: " + text);
                })
                .catch((error) => {
                    // console.error("Unable to copy text to clipboard: ", error);
                });
        } else {
            // Fallback method if Clipboard API is not supported
            var tempInput = document.createElement("input");
            tempInput.setAttribute("value", text);
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            // console.log("Text copied to clipboard successfully (fallback method): " + text);
        }

        setTooltipContent("Copied");

        setTimeout(() => {
            setTooltipContent("Click to copy");
        }, 1000);
    }


    const handleDownload = () => {
        // const text = getCurrentText();
        const blob = new Blob([currentText], { type: "text/plain;charset=utf-8" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `ads-${tab}_${new Date().getTime()}.txt`;
        a.click();

        URL.revokeObjectURL(url);
    };

    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between">
                <h1 className="heading fw_600"> Ads.txt </h1>
            </div>
            <div className="container_box--form-container border-0 p-0">
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={24}>
                            <div className="container_box--form-container">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="block-category block_category_adjustment">
                                                <div className="form_content_block--group mb-0">
                                                    <div className="d_flex justify_content_start mb_16 align-items-center" style={{ gap: '1.2rem' }}>
                                                        <h3 className='currently_live_text'>Currently Live</h3>
                                                        <span className='live_tag_design'>Live</span>
                                                    </div>
                                                    <div className="d_flex justify_content_between w_100 mb_10">
                                                        <div className="w-100">
                                                            <Radio.Group
                                                                value={tab}
                                                                onChange={handleTabChange}
                                                                className='radio_btn--group mb-0'>
                                                                <Radio.Button value="top">Top sellers list</Radio.Button>
                                                                <Radio.Button value="direct">Direct sellers list</Radio.Button>
                                                                <Radio.Button value="exhaustive">Exhaustive sellers list</Radio.Button>

                                                            </Radio.Group>
                                                        </div>
                                                        <span className='row_count_value_d2'>
                                                            <div className="export_btn_hover_d2 d-flex aling-items-center" style={{ gap: '0.6rem' }}>

                                                                {currentText.length === 0 ?
                                                                    <>

                                                                        <Button className="export_btn_d2"
                                                                            style={{ opacity: "0.5", pointerEvents: "none" }}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                <g clip-path="url(#clip0_9316_334)">
                                                                                    <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M3.33325 10H2.66659C2.31296 10 1.97382 9.85952 1.72378 9.60948C1.47373 9.35943 1.33325 9.02029 1.33325 8.66667V2.66667C1.33325 2.31304 1.47373 1.97391 1.72378 1.72386C1.97382 1.47381 2.31296 1.33333 2.66659 1.33333H8.66659C9.02021 1.33333 9.35935 1.47381 9.60939 1.72386C9.85944 1.97391 9.99992 2.31304 9.99992 2.66667V3.33333" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip0_9316_334">
                                                                                        <rect width="16" height="16" fill="white" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                        </Button>


                                                                        <Button className="export_btn_d2"
                                                                            style={{ opacity: "0.5", pointerEvents: "none" }}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M4.66772 6.66667L8.00106 10L11.3344 6.66667" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M8 10V2" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                        </Button>

                                                                    </>
                                                                    :
                                                                    <>
                                                                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                                                                            <Button className="export_btn_d2"
                                                                                onClick={() => { copyToClipboard(currentText) }}
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                    <g clip-path="url(#clip0_9316_334)">
                                                                                        <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M3.33325 10H2.66659C2.31296 10 1.97382 9.85952 1.72378 9.60948C1.47373 9.35943 1.33325 9.02029 1.33325 8.66667V2.66667C1.33325 2.31304 1.47373 1.97391 1.72378 1.72386C1.97382 1.47381 2.31296 1.33333 2.66659 1.33333H8.66659C9.02021 1.33333 9.35935 1.47381 9.60939 1.72386C9.85944 1.97391 9.99992 2.31304 9.99992 2.66667V3.33333" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_9316_334">
                                                                                            <rect width="16" height="16" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title="Download">
                                                                            <Button className="export_btn_d2"
                                                                                onClick={handleDownload}
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                    <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M4.66772 6.66667L8.00106 10L11.3344 6.66667" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M8 10V2" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </>
                                                                }
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="container_box--form-container mb-0 position-relative --new_code_copy_area">
                                    {currentText.length === 0 ?

                                        <pre className='code_text' style={{ padding: "10px", minHeight: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            No records found.
                                        </pre>
                                        :
                                        <pre className='code_text' style={{ padding: "10px" }}>
                                            {currentText}
                                        </pre>
                                    }
                                    <div className='clip_board_text'>
                                        <span>
                                            {lineCount} {(lineCount === 0 || lineCount === 1) ? "line" : "lines"}
                                        </span>
                                        <span>
                                            Copy the lines into your ads.txt of sites listed in adjacent section
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default AdsTxtPublisher
